import { useTranslation } from "react-i18next";
import { DocumentText1 } from "iconsax-react";
import { Badge } from "@/shared/ui";
import { formatDateForDisplay, formatMoneyKzt } from "@/shared/utils";
import { getActPipelineBadge } from "../../utils";
import type { MsbCompletionAct } from "../../types/msb";
import ActStatusPipeline from "../CalculationsPage/components/ActStatusPipeline";

interface Props {
  act: MsbCompletionAct;
  locale: "ru" | "kk" | "en";
  onClick?: () => void;
}

export default function MsbBigActCard({ act, locale, onClick }: Props) {
  const { t } = useTranslation("EmployeePortal");
  const badge = getActPipelineBadge(act.status, act.is_payment_approved, act.is_paid, t);

  return (
    <div
      className="p-6 radius-lg border surface-component-stroke flex flex-col gap-4 h-full cursor-pointer hover:surface-tertiary-fill"
      onClick={onClick}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 aspect-square radius-xs text-white radial-glow background-neutral-fill flex items-center justify-center shrink-0">
            <DocumentText1 size={20} color="currentColor" />
          </div>
          <div>
            <p className="text-body-bold-lg content-base-primary">
              {t("calculations.actDetail.actNumber", { number: act.act_number })}
            </p>
            <p className="text-body-regular-sm content-action-neutral">
              {formatDateForDisplay(act.period_start_date)} — {formatDateForDisplay(act.period_end_date)}
            </p>
          </div>
        </div>
        <Badge variant="soft" color={badge.color} text={badge.text} icon={badge.icon} />
      </div>

      <p className="text-display-sm content-base-primary">{formatMoneyKzt(act.amount, locale)}</p>

      <ActStatusPipeline status={act.status} isPaymentApproved={act.is_payment_approved} isPaid={act.is_paid} />

      <div className="flex items-center justify-between mt-auto pt-3 border-t surface-base-stroke">
        <p className="text-body-regular-sm content-action-neutral">{t("calculations.actDetail.total")}</p>
        <p className="text-body-bold-md content-base-primary">{formatMoneyKzt(act.amount, locale)}</p>
      </div>
    </div>
  );
}
